import { useEffect } from "react";

import { useTranslation } from "next-i18next";
import type { i18n as I18nInstance } from "i18next";

/**
 * Fetches and merges namespace JSON over the network (next-i18next client API).
 * Safe to call multiple times — i18next caches loaded namespaces.
 */
export async function loadI18nNamespaces(i18n: I18nInstance | undefined, namespaces: readonly string[]) {
    if (!i18n?.loadNamespaces || !namespaces.length) {
        return;
    }

    await i18n.loadNamespaces([...namespaces]);
}

/**
 * Client-side namespace preload. Use when a surface (nav, modal) mounts or opens
 * and the current page may not have requested those namespaces in SSR.
 */
export function useLoadI18nNamespaces(namespaces: readonly string[], enabled = true) {
    const { i18n } = useTranslation();

    useEffect(() => {
        if (!enabled) {
            return;
        }

        void loadI18nNamespaces(i18n, namespaces);
    }, [enabled, i18n, namespaces]);
}

export default useLoadI18nNamespaces;
